import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({
    endPoint: `dossier/campaign/${dossierId}`,
    method: 'GET',
    token: token
  })
}
